import { cursorPaginationFieldPolicy } from '../../../utils/policies/cursorPaginationFieldPolicy';
import type { TypePolicies } from '../../../utils/types/TypePolicies';

export const typePolicies: TypePolicies = {
  UserInbox: {
    fields: {
      items: cursorPaginationFieldPolicy([
        'filters',
        'orderBy',
        'page',
        ['first'],
      ]),
      legacyItems: cursorPaginationFieldPolicy(['filters', 'page', ['first']]),
    },
  },
};
